import { useState } from 'react';
import TextField from '@mui/material/TextField';

interface PropsNumberInput {
  placeholder?: string;
  value?: number;
  onChange?: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}
export const NumberInput: React.FC<PropsNumberInput> = ({
  placeholder, value, onChange,
  min, max, step,
}) => {
  const [val, setValue] = useState<number | ''>(value ?? '');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value === '' ? '' : parseFloat(event.target.value.replaceAll(",", "."));
    setValue(newValue);
    if (onChange && newValue !== '') onChange(newValue);
  };

  return (
    <TextField
      type="number"
      label={placeholder ?? "Número"}
      value={val}
      onChange={handleChange}
      InputProps={{
        inputProps: {
          min: min,
          max: max,
          step: step,
        }
      }}
      fullWidth
      variant="outlined"
    />
  );
};

export default NumberInput;